import { API } from '../constants/constants';

export const bulkUpdateServices = async (ids, fields) => {
  try {
    const res = await API.put(`/services/bulkUpdate`, {
      ids,
      fields,
    });
    return res.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const bulkUpdateInteractions = async (ids, fields) => {
  try {
    const res = await API.put(`/issues/bulkUpdate`, {
      ids,
      fields,
    });
    return res.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const bulkUpdateEngagements = async (ids, fields) => {
  try {
    const res = await API.put(`/engagements/bulkUpdate`, {
      ids,
      fields,
    });
    return res.data;
  } catch (e) {
    throw new Error(e.message);
  }
};
